import React, { lazy, Suspense } from 'react'
import ErrorBoundary from '@components/Layouts/ErrorBoundary'
const lazyLoad = (importFunc, { fallback = null } = { fallback: null }) => {
  const LazyComponent = lazy(importFunc)
  // eslint-disable-next-line react/display-name
  return props => (
    <Suspense fallback={fallback}>
      <ErrorBoundary>
        <LazyComponent {...props} />
      </ErrorBoundary>
    </Suspense>
  )
}

export default lazyLoad
